import { render } from "./UserDataTable.vue?vue&type=template&id=c3d7e51a&scoped=true"
import script from "./UserDataTable.vue?vue&type=script&lang=js"
export * from "./UserDataTable.vue?vue&type=script&lang=js"

import "./UserDataTable.vue?vue&type=style&index=0&id=c3d7e51a&scoped=true&lang=css"

import exportComponent from "/home/ec2-user/c2stem-server/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3d7e51a"]])

export default __exports__